import {createContext} from "react";

// This context stores the global variables for this program.
// It is consumed by the variables container.
const GlobalVariablesContext = createContext();

export default GlobalVariablesContext;
